import get from 'lodash/get';
import * as hoursView from './hours';
import * as holidaysView from './holidays';

export const Company = data => ({
  id: data.id,
  enabled: data.enabled,
  useDefaultSchedule: data.useDefaultSchedule,
  name: data.name,
  history: data.history,
  avatarUrl: data.avatarUrl,
  iconUrl: data.iconUrl,
  iconColor: data.iconColor,
  greeting: data.greeting,
  activeForm: data.activeForm,
  offhoursDisplay: data.offhoursDisplay,
  offhoursMessage: data.offhoursMessage,
  offhoursImageUrl: data.offhoursImageUrl,
  volumeControl: data.volumeControl,
  hours: data.hours,
  holidays: data.holidays,
  waitMessage: data.waitMessage,
  closableChat: data.closableChat,
  singleSessionChat: data.singleSessionChat,
  domainCriteria: data.domainCriteria,
  showTypingIndicatorCustomerWeb: data.showTypingIndicatorCustomerWeb,
  showTypingIndicatorWeb: data.showTypingIndicatorWeb,
  showBrandingIdentifier: data.showBrandingIdentifier,
});

export const responseDataToCompany = (responseData, hours, holidays) => {
  return new Company({
    id: get(responseData, 'id'),
    enabled: get(responseData, 'attributes.enabled'),
    useDefaultSchedule: get(responseData, 'attributes.useDefaultSchedule'),
    name: get(responseData, 'attributes.teamName'),
    history: !get(responseData, 'attributes.noHistory', false),
    avatarUrl: get(responseData, 'attributes.teamIconUrl'),
    iconUrl: get(responseData, 'attributes.embedIconUrl'),
    iconColor: get(responseData, 'attributes.embedIconColor'),
    greeting: get(responseData, 'attributes.greeting'),
    activeForm: get(responseData, 'attributes.activeForm'),
    offhoursDisplay: get(responseData, 'attributes.offhoursDisplay'),
    offhoursMessage: get(responseData, 'attributes.offhoursMessage'),
    offhoursImageUrl: get(responseData, 'attributes.offhoursImageUrl'),
    volumeControl: get(responseData, 'attributes.volumeControl'),
    hours,
    holidays,
    waitMessage: get(responseData, 'attributes.waitMessage'),
    closableChat: get(responseData, 'attributes.closableChat'),
    singleSessionChat: get(responseData, 'attributes.singleSessionChat'),
    domainCriteria: get(responseData, 'attributes.domainCriteria'),
    showTypingIndicatorCustomerWeb: get(responseData, 'attributes.showTypingIndicatorCustomerWeb'),
    showTypingIndicatorWeb: get(responseData, 'attributes.showTypingIndicatorWeb'),
    showBrandingIdentifier: get(responseData, 'attributes.showBrandingIdentifier'),
  });
};

export const responseToCompany = response => {
  return responseDataToCompany(response.data.data);
};

export const responseToCompanyWithHours = (companyResponse, hoursResponse) => {
  return responseDataToCompany(
    companyResponse.data.data,
    hoursView.responseToHours(hoursResponse),
    holidaysView.responseToHolidayList(hoursResponse),
  );
};
